import { VerticalLeftOutlined, VerticalRightOutlined } from '@ant-design/icons';
import React from 'react';

export {
  ApartmentOutlined as ProjectsIcon,
  ArrowLeftOutlined as BackNavIcon,
  ArrowRightOutlined as NextIcon,
  BarsOutlined as AssessmentsIcon,
  BulbOutlined as ThemeIcon,
  DashboardOutlined as WorkspaceIcon,
  DeleteOutlined as DeleteIcon,
  EditOutlined as EditIcon,
  FileTextOutlined as OutputIcon,
  FilterOutlined as FilterIcon,
  FolderOpenOutlined as AssetLibraryIcon,
  FolderOpenOutlined as FileCabinetIcon,
  HomeOutlined as HomeIcon,
  LoadingOutlined as GeneratingIcon,
  LockOutlined as SignInIcon,
  LogoutOutlined as SignOutIcon,
  MessageOutlined as ChatIcon,
  MoreOutlined as VerticalEllipsisIcon,
  PlayCircleOutlined as StepIcon,
  PlusOutlined as AddIcon,
  ProfileOutlined as PortfolioIcon,
  SearchOutlined as SearchIcon,
  SettingOutlined as ConnectionsIcon,
  SettingOutlined as SettingsIcon,
  ReadOutlined as SkillsIcon,
  StarFilled as SparkleIcon,
  TeamOutlined as ClientsIcon,
  UserOutlined as UserIcon,
  AreaChartOutlined as AreaChartIcon,
  ArrowDownOutlined as ArrowDownIcon,
  CloseOutlined as CloseIcon,
  CloudUploadOutlined as CloudUploadIcon,
  CopyOutlined as CopyIcon,
  DeploymentUnitOutlined as DeploymentIcon,
  DownloadOutlined as DownloadIcon,
  DownOutlined as DownIcon,
  EllipsisOutlined as HorizontalEllipsisIcon,
  FilterFilled as FilterFilledIcon,
  FundOutlined as FundIcon,
  InboxOutlined as InboxIcon,
  LeftOutlined as PrevIcon,
  LinkOutlined as LinkIcon,
  RedoOutlined as RefreshIcon,
  RightOutlined as NextPageIcon,
  SaveOutlined as SaveIcon,
  ThunderboltFilled as ThunderboltIcon,
  WarningOutlined as WarningIcon,
} from '@ant-design/icons';

export type LegacyIconType = 'vertical-right' | 'vertical-left';

export interface LegacyIconProps {
  type: LegacyIconType;
  className?: string;
}

export const Icon: React.FC<LegacyIconProps> = ({ type, className }) => {
  if (type === 'vertical-right') {
    return React.createElement(VerticalRightOutlined, { className });
  }
  return React.createElement(VerticalLeftOutlined, { className });
};
